<template>
  <qx-card title="地址档案列表">
    <LogRightDialog ref="logRightDialog" busiCode="100021" />
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <ImportBtn
          title="地址档案导入"
          bizCodes="imp1000200"
          fileUrl="地址档案导入模板.xlsx"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="cityAddressFileBO.ajax?cmd=queryPage"
          :params="fullSearchData"
          bizName="地址档案导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            ></el-table-column
          ></template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="160"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    showCondition: true,
                    name: '修改',
                    event: () => toEdit(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '查看',
                    event: () => toDetail(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '删除',
                    event: () => toDelete(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.afId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import ImportBtn from 'components/importBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  cityAddressQueryPage,
  deleteByAfId,
} from 'api/distribution';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ExportBtn,
    ImportBtn,
    TableBtn,
    TableSetting,
  },


  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'customerName', label: '客户名称', fixed: true },
          { prop: 'addressTypeName', label: '地址类型' },
          { prop: 'consignee', label: '收货方' },
          { prop: 'addressName', label: '地址名称' },
          { prop: 'addressNavigation', label: '导航地址' },
          { prop: 'addressDtl', label: '详细地址' },
          { prop: 'estimatedStayTime', label: '停留时间（分钟）' },
          { prop: 'linkMan1', label: '第一联系人' },
          { prop: 'linkManPhone1', label: '第一联系人电话' },
          { prop: 'linkMan2', label: '第二联系人' },
          { prop: 'linkManPhone2', label: '第二联系人电话' },
          { prop: 'opRemarks', label: '操作说明' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: cityAddressQueryPage,
    toDetail (item) {
      this.jump({
        label: `查看地址档案-${item.addressName}`,
        url: `/manage/distribution/addressArchives/detail?id=${item ? item.afId : ''}`,
        full: true,
      });
    },
    toEdit (item) {
      this.jump({
        label: item ? `修改地址档案-${item.addressName}` : '新增地址档案',
        url: `/manage/distribution/addressArchives/edit?id=${item ? item.afId : ''}`,
        full: true,
      });
    },
    async toDelete (item) {
      const confirmRes = await this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
      if (confirmRes === 'confirm') {
        const res = await deleteByAfId({
          afId: item.afId,
        });
        if (!res.failed) {
          this.$message.success('删除成功');
          this.getData();
        }
      }
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
